import { MemberFee } from 'src/modules/member/models/memberFee';
import { MemberFeeRequest } from 'src/modules/member/models/memberFeeRequest';
import { setPagingParams } from '../functions/createPagingParams';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'Memberfee';

export const getMemberfeesByMemberIds = (pageIndex, pageSize, sortCol, sortDir, memberIds, invoiceTemplateId, withFamilyMembers) => {
  let extraQuery = '';
  if (memberIds && memberIds.length > 0) {
    memberIds.forEach((x) => {
      extraQuery += `&memberIds=${x}`;
    });
  }

  if (withFamilyMembers !== undefined) {
    extraQuery += `&withFamilyMembers=${withFamilyMembers}`;
  }

  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}&invoiceTemplateId=${invoiceTemplateId}`;
  return AxiosInstance.get<PagedResult<MemberFee>>(endpoint);
};

export const createMemberFee = (data: MemberFeeRequest) => {
  return AxiosInstance.post<MemberFeeRequest>(controller, data);
};

// Namnen på de mottagare som betalar via autogiro, Swish eller Stripe — egen prenumeration eller via
// hushållets huvudmedlem. Tom lista betyder att avgiftsfakturan får skapas.
export const getMembersWithRecurringPayment = (memberIds: number[]) => {
  const query = memberIds.map((id) => `memberIds=${id}`).join('&');

  return AxiosInstance.get<string[]>(`${controller}/RecurringPayment?${query}`);
};
